import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Avatar,
  Flex,
  Text,
  useColorModeValue,
  Button,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Select,
  Badge,
  Divider,
  Image,
  Icon,
  IconButton,
} from '@chakra-ui/react';
import { TabContent, TabPane } from 'reactstrap';
import userimage from '../../../../assets/img/auth/Default_profileoic.jpg';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AssignedWork from './AssignedWork';
import EmployeeDoc from './EmployeeDoc';
import EmployeeEmergencyContact from './EmployeeEmergencyContact';
import EmployeeEductionDetails from './EmployeeEductionDetails';
import Spinner from 'components/common/Spinner';
import EmployeeBankdetails from './EmployeeBankDetails';
import Personal from './Personal';
import Work from './Work';
import { decryptData } from 'utils/crypto';
import gradient from 'assets/img/gradient.jpg';
import {
  MdPerson,
  MdBusiness,
  MdWork,
  MdDescription,
  MdCalendarToday,
  MdAccountBalance,
  MdFamilyRestroom,
  MdSchool,
  MdAccountTree,
  MdEmail,
  MdEdit,
  MdStar,
  MdAccessTime,
  MdArrowBack,
} from 'react-icons/md';
import { Tooltip } from '@chakra-ui/react';
import { FaEnvelope, FaBriefcase, FaUser } from 'react-icons/fa';
import { Plus } from 'lucide-react';
import { demoProfileDetails } from 'components/demodata/Dummydata';
import { demoManagers } from 'components/demodata/Dummydata';

/* ── live clock ── */
const useClock = () => {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return time.toLocaleTimeString('en-GB');
};

/* ── avatar helpers ── */
const getInitials = (name = '') =>
  name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);

const getAvatarColor = (name = '') => {
  const colors = ['#6B46C1', '#3182CE', '#E53E3E', '#38A169', '#D69E2E', '#00B5D8'];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
};

const ViewProfile = () => {
  const { id } = useParams();
  const inputRef = useRef(null);
  const [image, setImage] = useState('');
  const [activeTab, setActiveTab] = useState('1');
  const [isEditingPersonal, setIsEditingPersonal] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isEditingBasicInfo, setIsEditingBasicInfo] = useState(false);
  const [isEditingWorkInfo, setIsEditingWorkInfo] = useState(false);
  const [eligible, setIsEligible] = useState(false);
  const [uploaded, isUploaded] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(false);
  const [disableContact, setDisableContact] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [inputErrors, setInputErrors] = useState({});
  const [isIdChanged, setIsIdChanged] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [reportingManagers, setReportingManagers] = useState([]);
  const [reportingLoading, setReportingLoading] = useState(false);
  const [managersMaster, setManagersMaster] = useState([]);
  const [isManagerModalOpen, setIsManagerModalOpen] = useState(false);
  const [manager1, setManager1] = useState('');
  const [manager2, setManager2] = useState('');
  const [managerSubmitting, setManagerSubmitting] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const clock = useClock();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    dob: '',
    blood_group: '',
    marital_status: '',
    gender: '',
    official_email_id: '',
    personal_email_id: '',
    phone_number: '',
    alternate_phone_number: '',
    currentAddress: '',
    permanentAddress: '',
    employee_id: '',
    date_of_joining: '',
    probation_period: '',
    employee_type: '',
    work_location: '',
    department: '',
    department_Id: '',
    subDepartment: '',
    designation: '',
    subdepartment_Id: '',
    designation_Id: '',
  });

  /* ── validation helpers ── */
  const handleDateChange = (event) => {
    const { name, value } = event.target;
    const currentDate = new Date();
    const selectedDate = new Date(value);
    const age = currentDate.getFullYear() - selectedDate.getFullYear();
    const isOfAge =
      age > 18 ||
      (age === 18 &&
        (currentDate.getMonth() > selectedDate.getMonth() ||
          (currentDate.getMonth() === selectedDate.getMonth() &&
            currentDate.getDate() >= selectedDate.getDate())));

    let errorMessage = '';
    let disable = false;

    if (selectedDate.getFullYear() > currentDate.getFullYear()) {
      errorMessage = 'Invalid date of birth. The DOB must not exceed the current year.';
      disable = true;
    } else if (!isOfAge) {
      errorMessage = 'User must be at least 18 years old.';
      disable = true;
    }

    setFormErrors((prev) => ({ ...prev, [name]: errorMessage }));
    setDisable(disable);
    handleChange(event);
  };

  const validateEmail = (event) => {
    const { name, value } = event.target;
    let errorMessage = '';
    if (!value.includes('@')) {
      errorMessage = "Invalid email. The email must contain '@'.";
      setDisableContact(true);
    } else {
      setDisableContact(false);
    }
    setInputErrors((prev) => ({ ...prev, [name]: errorMessage }));
    handleChange(event);
  };

  const validatePhoneNumber = (event) => {
    const { name, value } = event.target;
    let errorMessage = '';
    if (value.length < 10) {
      errorMessage = 'Invalid phone number. The phone number must contain at least 10 digits.';
      setDisableContact(true);
    } else {
      setDisableContact(false);
    }
    setInputErrors((prev) => ({ ...prev, [name]: errorMessage }));
    handleChange(event);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'employee_id' && value !== originalData.employee_id)
      setIsIdChanged(true);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageclick = () => inputRef.current.click();

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImage(reader.result);
      reader.readAsDataURL(file);
      isUploaded(true);
    }
  };

  const loginid = decryptData(Cookies.get('role_id'));
  const isAdmin = Number(loginid) === 1 || Number(loginid) === 2;

  /* ── helper: build managers array from API responses ── */
  const buildManagersForUser = (matchedUser, managersList) => {
    const getManagerInfo = (recordId) => {
      const found = managersList.find(
        (m) => m.reporting_manager_record_id === recordId,
      );
      return {
        department_name: found?.department_name || '—',
        designation_name: found?.designation_name || '—',
      };
    };

    return [
      matchedUser.reporting_manager1_name && {
        id: matchedUser.reporting_manager1_record_id,
        name: matchedUser.reporting_manager1_name,
        ...getManagerInfo(matchedUser.reporting_manager1_record_id),
        slot: 1,
      },
      matchedUser.reporting_manager2_name && {
        id: matchedUser.reporting_manager2_record_id,
        name: matchedUser.reporting_manager2_name,
        ...getManagerInfo(matchedUser.reporting_manager2_record_id),
        slot: 2,
      },
    ].filter(Boolean);
  };

  /* ── fetch reporting managers on mount ── */
  useEffect(() => {
    const fetchReportingManagersForUser = async () => {
      try {
        setReportingLoading(true);

          const isDemoMode =
        localStorage.getItem("demoMode") === "true";

      if (isDemoMode) {
        setReportingManagers(demoManagers);
        return;
      }

        const [reportingRes, managersRes] = await Promise.all([
          httpInjectorService.getUsersReportingList(),
          httpInjectorService.getManagersList(),
        ]);

        if (reportingRes?.status === 'success' && Array.isArray(reportingRes.data)) {
          const matchedUser = reportingRes.data.find(
            (user) => String(user.user_id) === String(id),
          );

          if (matchedUser) {
            const managersList = managersRes?.data || [];
            setReportingManagers(buildManagersForUser(matchedUser, managersList));
          } else {
            setReportingManagers([]);
          }
        }
      } catch (error) {
        console.error('Error fetching reporting managers:', error);
        setReportingManagers([]);
      } finally {
        setReportingLoading(false);
      }
    };

    fetchReportingManagersForUser();
  }, [id]);

  /* ── fetch managers master list for admin modal ── */
  useEffect(() => {
    const fetchManagersList = async () => {
      if (!isAdmin) return;
      try {
        const res = await httpInjectorService.getManagersList();
        if (res?.status === 'success') setManagersMaster(res.data || []);
      } catch (error) {
        console.error('Failed to fetch managers list', error);
      }
    };
    fetchManagersList();
  }, [isAdmin]);

  /* ── shared refresh function ── */
  const refreshManagers = async () => {
    try {
      const [reportingRes, managersRes] = await Promise.all([
        httpInjectorService.getUsersReportingList(),
        httpInjectorService.getManagersList(),
      ]);

      if (reportingRes?.status === 'success' && Array.isArray(reportingRes.data)) {
        const matchedUser = reportingRes.data.find(
          (user) => String(user.user_id) === String(id),
        );

        if (matchedUser) {
          const managersList = managersRes?.data || [];
          setReportingManagers(buildManagersForUser(matchedUser, managersList));
        } else {
          setReportingManagers([]);
        }
      }
    } catch (error) {
      console.error('Error refreshing managers:', error);
    }
  };

  const openManagerModal = () => {
    setManager1(reportingManagers?.[0]?.id || '');
    setManager2(reportingManagers?.[1]?.id || '');
    setIsManagerModalOpen(true);
  };

  const closeManagerModal = () => {
    setIsManagerModalOpen(false);
    setManager1('');
    setManager2('');
  };

  const handleManagerSubmit = async () => {
    if (!id) return;
    if (!manager1 && !manager2) {
      toast.error('Select at least one manager');
      return;
    }
    if (manager1 && manager2 && manager1 === manager2) {
      toast.error('Managers must be different');
      return;
    }

    const payload = {
      user_id: id,
      manager_id1: manager1 ? Number(manager1) : undefined,
      manager_id2: manager2 ? Number(manager2) : undefined,
    };

    try {
      setManagerSubmitting(true);
      const hasExistingManagers = reportingManagers.length > 0;
      const res = hasExistingManagers
        ? await httpInjectorService.updateReportingManager(payload)
        : await httpInjectorService.assignReportingManager(payload);

      if (res?.status === 'success') {
        toast.success(res.message || 'Managers updated');
        closeManagerModal();
        await refreshManagers();
      } else {
        toast.error(res?.message || 'Operation failed');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong while updating managers');
    } finally {
      setManagerSubmitting(false);
    }
  };

  const handleRemoveManager = async (slot) => {
    if (!id) return;
    const payload = {
      user_id: id,
      remove_manager1: slot === 1,
      remove_manager2: slot === 2,
    };
    try {
      setDeleteLoading(true);
      const res = await httpInjectorService.removeUserReportingManager(payload);
      if (res?.status === 'success') {
        toast.success(res?.message || 'Manager removed');
        await refreshManagers();
        setDeleteData(null);
      } else {
        toast.error(res?.message || 'Failed to remove manager');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to remove manager');
    } finally {
      setDeleteLoading(false);
    }
  };

  const saveImage = async () => {
    const adminid = decryptData(Cookies.get('user_id'));
    const formDataa = new FormData();
    formDataa.append('file', inputRef.current.files[0]);
    formDataa.append('id', id);
    formDataa.append('adminid', adminid);
    try {
      const response = await httpInjectorService.uploadImage(formDataa);
      if (response.status === 'success') {
        toast.success('Image saved successfully.', { position: 'top-right', autoClose: 3000 });
        isUploaded(!isUploaded);
      } else {
        toast.error('Failed to save image.', { position: 'top-right', autoClose: 3000 });
      }
    } catch (err) {
      toast.error('Error while saving image.', { position: 'top-right', autoClose: 3000 });
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const saveData = async () => {
    try {
      setIsSaving(true);
      const numericFields = ['probation_period'];
      const updatedFields = Object.keys(formData).reduce((acc, key) => {
        const currentValue = formData[key];
        const originalValue = originalData[key];
        if (currentValue === originalValue) return acc;
        if (numericFields.includes(key) && (currentValue === '' || currentValue === ' ')) return acc;
        acc[key] = currentValue === '' ? ' ' : currentValue;
        return acc;
      }, {});

      if (Object.keys(updatedFields).length === 0 && !isIdChanged) {
        toast.info('No changes detected.');
        return;
      }

      if (!id) return;

      const payload = { user_id: id, ...updatedFields, isIdChanged };
      const response = await httpInjectorService.updateprofiledetails(payload);

      if (response.status === 'success') {
        toast.success(response.message, { position: 'top-right', autoClose: 3000 });
        if (uploaded === true) saveImage();
        setIsEditingPersonal(false);
      } else {
        toast.error(response.message, { position: 'top-right', autoClose: 3000 });
      }
    } catch (error) {
      toast.error('Failed to update', { position: 'top-right', autoClose: 3000 });
    } finally {
      setIsIdChanged(false);
      setIsSaving(false);
    }
  };

  const saveContactData = async () => {
    await saveData();
    setIsEditingContact(false);
  };

  useEffect(() => {
    if (loginid === 2) setIsEligible(true);
    getData();
  }, [loginid, id]);

  useEffect(() => {
    getData();
  }, []);

  // const getData = async () => {
  //   try {
  //     if (!id) throw new Error('Role ID not found in cookies');
  //     const getResponse = await httpInjectorService.getProfiledetails(id);
  //     if (getResponse && Array.isArray(getResponse.data) && getResponse.data.length > 0) {
  //       const profileData = getResponse.data[0];
  //       setImage(profileData.image_url || '');
  //       const mapped = {
  //         username: profileData.username || '',
  //         dob: profileData.dob ? new Date(profileData.dob).toISOString().split('T')[0] : '',
  //         blood_group: profileData.blood_group || '',
  //         marital_status: profileData.marital_status || '',
  //         gender: profileData.gender || '',
  //         official_email_id: profileData.official_email_id || '',
  //         personal_email_id: profileData.personal_email_id || '',
  //         phone_number: profileData.phone_number || '',
  //         alternate_phone_number: profileData.alternate_phone_number || '',
  //         current_address: profileData.current_address || '',
  //         permanent_address: profileData.permanent_address || '',
  //         employee_id: profileData.employee_id || '',
  //         date_of_joining: profileData.date_of_joining
  //           ? new Date(profileData.date_of_joining).toISOString().split('T')[0]
  //           : '',
  //         probation_period: profileData.probation_period || '',
  //         employee_type: profileData.employee_type || '',
  //         work_location: profileData.work_location || '',
  //         designations: profileData.designations || '',
  //         department_name: profileData.department_name || '',
  //         subDepartment: profileData.subdepartment || '',
  //       };
  //       setFormData(mapped);
  //       setOriginalData(mapped);
  //     } else {
  //       throw new Error('Invalid response format');
  //     }
  //   } catch (error) {
  //     toast.error('Failed to fetch profile details', { position: 'top-right', autoClose: 3000 });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getData = async () => {
  try {
    const isDemoMode = localStorage.getItem("demoMode") === "true";

    let profileData;

    if (isDemoMode) {
      profileData = demoProfileDetails[0];
    } else {
      if (!id) throw new Error("Role ID not found");

      const getResponse = await httpInjectorService.getProfiledetails(id);

      if (
        !getResponse ||
        !Array.isArray(getResponse.data) ||
        getResponse.data.length === 0
      ) {
        throw new Error("Invalid response format");
      }

      profileData = getResponse.data[0];
    }

    setImage(profileData.image_url || "");

    const mapped = {
      username: profileData.username || "",
      dob: profileData.dob
        ? new Date(profileData.dob).toISOString().split("T")[0]
        : "",
      blood_group: profileData.blood_group || "",
      marital_status: profileData.marital_status || "",
      gender: profileData.gender || "",
      official_email_id: profileData.official_email_id || "",
      personal_email_id: profileData.personal_email_id || "",
      phone_number: profileData.phone_number || "",
      alternate_phone_number: profileData.alternate_phone_number || "",
      current_address: profileData.current_address || "",
      permanent_address: profileData.permanent_address || "",
      employee_id: profileData.employee_id || "",
      date_of_joining: profileData.date_of_joining
        ? new Date(profileData.date_of_joining).toISOString().split("T")[0]
        : "",
      probation_period: profileData.probation_period || "",
      employee_type: profileData.employee_type || "",
      work_location: profileData.work_location || "",
      designations: profileData.designations || "",
      department_name: profileData.department_name || "",
      subDepartment: profileData.subdepartment || "",
    };

    setFormData(mapped);
    setOriginalData(mapped);
  } catch (error) {
    toast.error("Failed to fetch profile details", {
      position: "top-right",
      autoClose: 3000,
    });
  } finally {
    setLoading(false);
  }
};

  const handleBackButton = () => navigate('/admin/directory');

  const options = async () => {
    try {
      const response = await httpInjectorService.getdepartment();
      if (response.status === 'success') setDepartments(response.data);
    } catch (err) {}
  };

  const fetchDesignations = async () => {
    try {
      const response = await httpInjectorService.getdesignation();
      if (response.status === 'success') setDesignations(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    options();
    fetchDesignations();
  }, []);

  useEffect(() => {
    if (formData.department === '' || departments.length === 0) return;
    const dept_details = departments.filter(
      (department) => department.department_name === formData.department,
    );
    if (dept_details.length === 0) return;
    setSubDepartments(dept_details[0].subdepartments);
  }, [formData, departments]);

  /* ── tab definitions ── */
  const baseTabs = [
    { id: '1', label: 'Personal', icon: MdPerson },
    { id: '2', label: 'Work', icon: MdWork },
    { id: '3', label: 'Reporting', icon: MdAccountTree },
  ];
  const eligibleTabs = [
    { id: '4', label: 'Documents', icon: MdDescription },
    { id: '5', label: 'Work Week', icon: MdCalendarToday },
    { id: '6', label: 'Bank Details', icon: MdAccountBalance },
    { id: '7', label: 'Family', icon: MdFamilyRestroom },
    { id: '8', label: 'Education', icon: MdSchool },
  ];
  const tabs = eligible ? [...baseTabs, ...eligibleTabs] : baseTabs;

  /* ── color tokens ── */
  const cardBg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.100', 'gray.700');
  const textMuted = useColorModeValue('gray.500', 'gray.400');

  if (loading) {
    return (
      <Flex direction="column" align="center" justify="flex-start" w="100%" mt="80px">
        <Spinner size="xl" color="purple.500" />
      </Flex>
    );
  }

  return (
    <>
      {/* ── gradient header banner ── */}
      <Box
        w="100%"
        h={{ base: '110px', md: '140px' }}
        bgSize="cover"
        bgPosition="center"
        borderRadius="0 0 24px 24px"
        mb="-90px"
        position="relative"
      />

      {/* ── go back button ── */}
      <Box top={{ base: 3, md: 4 }} left={{ base: 3, md: 4 }}>
        <Tooltip label="Go Back" aria-label="Go Back">
          <Box
            as="button"
            ml={5}
            mb={2}
            onClick={handleBackButton}
            display="flex"
            alignItems="center"
            gap="8px"
            bg="white"
            backdropFilter="blur(10px)"
            border="1px solid"
            borderColor="whiteAlpha.400"
            borderRadius="full"
            px={3.5}
            py={3.5}
            color="black"
            fontSize="13px"
            fontWeight="600"
            cursor="pointer"
            transition="all 0.2s ease"
            sx={{
              '&:hover': { background: 'rgba(255,255,255,0.30)', transform: 'translateX(-3px)' },
              '&:active': { transform: 'translateX(-1px)' },
            }}
          >
            <Box as={MdArrowBack} fontSize="18px" flexShrink={0} />
          </Box>
        </Tooltip>
      </Box>

      {/* ── main two-column layout ── */}
      <Box minH="100vh" px={{ base: 3, md: 6 }} pb={10}>
        <Flex gap={5} align="flex-start" direction={{ base: 'column', lg: 'row' }} maxW="1400px" mx="auto">

          {/* ── left profile card ── */}
          <Box
            bg={cardBg}
            borderRadius="24px"
            boxShadow="0 8px 32px rgba(107,70,193,0.10)"
            border="1px solid"
            borderColor={border}
            w={{ base: '100%', lg: '270px' }}
            flexShrink={0}
            pt={6}
            pb={5}
            px={5}
            position={{ base: 'relative', lg: 'sticky' }}
            top={{ lg: '90px' }}
          >
            <Box position="absolute" top={4} right={4} color="yellow.400" fontSize="20px">
              <MdStar />
            </Box>

            <Flex direction="column" align="center" mb={4}>
              <Box position="relative" mb={3}>
                <Box
                  w="110px"
                  h="110px"
                  borderRadius="full"
                  overflow="hidden"
                  border="4px solid white"
                  boxShadow="0 4px 20px rgba(107,70,193,0.18)"
                >
                  <Image src={image || userimage} alt={formData.username} w="100%" h="100%" objectFit="cover" />
                </Box>
                {eligible && (
                  <Box
                    as="button"
                    onClick={handleImageclick}
                    position="absolute"
                    bottom="2px"
                    right="2px"
                    w="28px"
                    h="28px"
                    borderRadius="full"
                    bg="white"
                    border="1.5px solid"
                    borderColor="gray.200"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="sm"
                    _hover={{ bg: 'purple.50' }}
                  >
                    <Box as={MdEdit} fontSize="14px" color="gray.600" />
                  </Box>
                )}
                <input type="file" ref={inputRef} onChange={handleImageChange} style={{ display: 'none' }} accept="image/*" />
              </Box>

              <Text fontWeight="700" fontSize="lg" color="gray.800" mb={0} textAlign="center">
                {formData.username || '—'}
              </Text>
            </Flex>

            <Divider borderColor={border} mb={4} />

            <Flex direction="column" gap={3} mb={5}>
              <Flex align="center" gap={3}>
                <Box w="32px" h="32px" borderRadius="full" bg="gray.100" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                  <Box as={MdEmail} fontSize="16px" color="gray.500" />
                </Box>
                <Text fontSize="xs" color={textMuted} mb={0} noOfLines={1}>
                  {formData.official_email_id || '—'}
                </Text>
              </Flex>

              <Flex align="center" gap={3}>
                <Box w="32px" h="32px" borderRadius="full" bg="gray.100" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                  <Box as={MdBusiness} fontSize="16px" color="gray.500" />
                </Box>
                <Text fontSize="xs" color={textMuted} mb={0}>
                  {formData.department_name || '—'}
                </Text>
              </Flex>

              <Flex align="center" gap={3}>
                <Box w="32px" h="32px" borderRadius="full" bg="gray.100" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                  <Box as={MdAccessTime} fontSize="16px" color="gray.500" />
                </Box>
                <Text fontSize="xs" color={textMuted} mb={0} fontVariantNumeric="tabular-nums">
                  {clock}
                </Text>
              </Flex>
            </Flex>

            <Divider borderColor={border} mb={4} />

            <Flex justify="center" gap={3}>
              <Tooltip label={formData.official_email_id} bg="white" color="gray.800" border="1px solid" borderColor="gray.200" boxShadow="md" hasArrow>
                <IconButton icon={<Icon as={FaEnvelope} />} aria-label="Email" />
              </Tooltip>
              <Tooltip label={formData.username} bg="white" color="gray.800" border="1px solid" borderColor="gray.200" boxShadow="md" hasArrow>
                <IconButton icon={<Icon as={FaUser} />} aria-label="Profile" />
              </Tooltip>
              <Tooltip label={formData.department_name} bg="white" color="gray.800" border="1px solid" borderColor="gray.200" boxShadow="md" hasArrow>
                <IconButton icon={<Icon as={FaBriefcase} />} aria-label="Work" />
              </Tooltip>
            </Flex>
          </Box>

          {/* ── right tab panel ── */}
          <Box flex={1} minW={0} w="100%" mt={{ base: 0, md: 0, lg: -14 }} display="flex" flexDirection="column">

            {/* tab bar */}
            <Box bg={cardBg} borderRadius="20px" p="6px" mb={4} boxShadow="0 4px 20px rgba(0,0,0,0.06)" border="1px solid" borderColor={border}>
              <Flex gap={1} overflowX="auto" css={{ '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none' }}>
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.id;
                  return (
                    <Button
                      key={tab.id}
                      onClick={() => toggleTab(tab.id)}
                      bg={isActive ? 'purple.500' : 'transparent'}
                      color={isActive ? 'white' : 'gray.600'}
                      borderRadius="14px"
                      px={{ base: 3, md: 5 }}
                      py={{ base: 4, md: 5 }}
                      fontWeight="600"
                      fontSize="13px"
                      whiteSpace="nowrap"
                      flexShrink={0}
                      _hover={{ bg: isActive ? 'purple.600' : 'gray.100' }}
                      transition="all 0.2s"
                      title={tab.label}
                      aria-label={tab.label}
                      leftIcon={<Box as={tab.icon} fontSize="16px" display={{ base: 'block', md: 'none' }} />}
                    >
                      <Box as="span" display={{ base: 'none', md: 'inline' }}>{tab.label}</Box>
                    </Button>
                  );
                })}
              </Flex>
            </Box>

            {/* tab content */}
            <Box
              bg={cardBg}
              borderRadius="20px"
              p={3}
              boxShadow="0 4px 20px rgba(0,0,0,0.06)"
              border="1px solid"
              borderColor={border}
              maxHeight="75vh"
              overflowY="auto"
              paddingRight="4px"
              sx={{
                scrollbarWidth: 'thin',
                scrollbarColor: '#805AD5 #f1f1f1',
                '&::-webkit-scrollbar': { width: '6px' },
                '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
                '&::-webkit-scrollbar-thumb': { background: '#805AD5', borderRadius: '10px' },
                '&::-webkit-scrollbar-thumb:hover': { background: '#6B46C1' },
              }}
            >
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Personal
                    saveContactData={saveContactData}
                    isSaving={isSaving}
                    isEditingPersonal={isEditingPersonal}
                    eligible={eligible}
                    setIsEditingPersonal={setIsEditingPersonal}
                    formData={formData}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    formErrors={formErrors}
                    image={image}
                    inputRef={inputRef}
                    handleImageChange={handleImageChange}
                    handleImageclick={handleImageclick}
                    saveData={saveData}
                    disable={disable}
                    isEditingContact={isEditingContact}
                    setIsEditingContact={setIsEditingContact}
                    validateEmail={validateEmail}
                    inputErrors={inputErrors}
                    validatePhoneNumber={validatePhoneNumber}
                    disableContact={disableContact}
                  />
                </TabPane>

                <TabPane tabId="2">
                  <Work
                    isSaving={isSaving}
                    eligible={eligible}
                    isEditingBasicInfo={isEditingBasicInfo}
                    setIsEditingBasicInfo={setIsEditingBasicInfo}
                    formData={formData}
                    handleChange={handleChange}
                    saveData={saveData}
                    isEditingWorkInfo={isEditingWorkInfo}
                    setIsEditingWorkInfo={setIsEditingWorkInfo}
                    departments={departments}
                    setFormData={setFormData}
                    subDepartments={subDepartments}
                    designations={designations}
                  />
                </TabPane>

                {/* ── Reporting Tab ── */}
                <TabPane tabId="3">
                  <Box p={2}>
                    <Flex align="center" justify="space-between" mb={6}>
                      <Flex align="center" gap={2}>
                        <Box w="4px" h="22px" bg="purple.500" borderRadius="full" />
                        <Text fontWeight="bold" fontSize="lg" mb={0} color="gray.700">
                          Reporting Managers
                        </Text>
                        {reportingManagers.length > 0 && (
                          <Badge colorScheme="purple" borderRadius="full" px={2}>
                            {reportingManagers.length}
                          </Badge>
                        )}
                      </Flex>
                      {isAdmin && (
                        <Button
                          size="sm"
                          colorScheme="teal"
                          onClick={openManagerModal}
                          leftIcon={<Plus display={{ base: 'block', md: 'none' }} />}
                        >
                          <Box display={{ base: 'none', md: 'block' }}>Manage Reporting Managers</Box>
                        </Button>
                      )}
                    </Flex>

                    {reportingLoading && (
                      <Flex justify="center" align="center" h="120px">
                        <Spinner size="lg" color="purple.500" thickness="3px" />
                      </Flex>
                    )}

                    {!reportingLoading && reportingManagers.length === 0 && (
                      <Flex direction="column" align="center" justify="center" h="120px" borderRadius="xl" border="1px dashed" borderColor="gray.200" color="gray.400" gap={2}>
                        <MdAccountTree size={28} />
                        <Text fontSize="sm">No reporting manager assigned</Text>
                      </Flex>
                    )}

                    {!reportingLoading && reportingManagers.length > 0 && (
                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        {reportingManagers.map((manager) => {
                          const bg = getAvatarColor(manager.name);
                          return (
                            <Box
                              key={`${manager.slot}-${manager.id}`}
                              bg="white"
                              borderRadius="2xl"
                              border="1px solid"
                              borderColor="gray.100"
                              boxShadow="0 4px 20px rgba(107,70,193,0.08)"
                              overflow="hidden"
                              transition="all 0.25s ease"
                              _hover={{
                                transform: 'translateY(-3px)',
                                boxShadow: '0 12px 32px rgba(107,70,193,0.18)',
                                borderColor: 'purple.100',
                              }}
                            >
                              <Box h="5px" bg={bg} />
                              <Box p={4}>
                                <Flex align="center" gap={3} mb={4}>
                                  <Box
                                    w="46px"
                                    h="46px"
                                    borderRadius="full"
                                    bg={bg}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    color="white"
                                    fontWeight="bold"
                                    fontSize="md"
                                    flexShrink={0}
                                    boxShadow={`0 4px 12px ${bg}55`}
                                  >
                                    {getInitials(manager.name)}
                                  </Box>
                                  <Box>
                                    <Text fontWeight="bold" fontSize="sm" color="gray.800" mb={0}>
                                      {manager.name}
                                    </Text>
                                    <Badge colorScheme="purple" variant="subtle" fontSize="10px" borderRadius="full">
                                      Manager {manager.slot}
                                    </Badge>
                                  </Box>
                                </Flex>

                                <Divider mb={3} borderColor="gray.100" />

                                <Flex direction="column" gap={2}>
                                  <Flex align="center" gap={2}>
                                    <Box color="purple.400" flexShrink={0}><MdBusiness size={15} /></Box>
                                    <Text fontSize="xs" color="gray.500" mb={0} fontWeight="medium">Department</Text>
                                    <Text fontSize="xs" color="gray.700" mb={0} ml="auto" fontWeight="semibold">
                                      {manager.department_name || '—'}
                                    </Text>
                                  </Flex>
                                  <Flex align="center" gap={2}>
                                    <Box color="purple.400" flexShrink={0}><MdWork size={15} /></Box>
                                    <Text fontSize="xs" color="gray.500" mb={0} fontWeight="medium">Designation</Text>
                                    <Text fontSize="xs" color="gray.700" mb={0} ml="auto" fontWeight="semibold">
                                      {manager.designation_name || '—'}
                                    </Text>
                                  </Flex>
                                </Flex>

                                {isAdmin && (
                                  <Button
                                    size="xs"
                                    colorScheme="red"
                                    variant="ghost"
                                    mt={3}
                                    w="full"
                                    borderRadius="lg"
                                    _hover={{ bg: 'red.100' }}
                                    onClick={() =>
                                      setDeleteData({
                                        slot: manager.slot,
                                        managerName: manager.name,
                                        userName: formData.username,
                                      })
                                    }
                                  >
                                    Remove Manager
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          );
                        })}
                      </SimpleGrid>
                    )}
                  </Box>
                </TabPane>

                <TabPane tabId="4"><EmployeeDoc activeTab={activeTab} /></TabPane>
                <TabPane tabId="5"><AssignedWork activeTab={activeTab} /></TabPane>
                <TabPane tabId="6"><EmployeeBankdetails activeTab={activeTab} /></TabPane>
                <TabPane tabId="7"><EmployeeEmergencyContact activeTab={activeTab} /></TabPane>
                <TabPane tabId="8"><EmployeeEductionDetails activeTab={activeTab} /></TabPane>
              </TabContent>
            </Box>
          </Box>
        </Flex>
      </Box>

      {/* ── Manage Managers Modal ── */}
      {isAdmin && (
        <Modal isOpen={isManagerModalOpen} onClose={closeManagerModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Manage Reporting Managers</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Select placeholder="Select Manager 1" value={manager1} onChange={(e) => setManager1(e.target.value)} mb={3}>
                {managersMaster.map((manager) => (
                  <option key={manager.reporting_manager_record_id} value={manager.reporting_manager_record_id}>
                    {manager.manager_name}
                  </option>
                ))}
              </Select>
              <Select placeholder="Select Manager 2 (Optional)" value={manager2} onChange={(e) => setManager2(e.target.value)}>
                {managersMaster.map((manager) => (
                  <option key={manager.reporting_manager_record_id} value={manager.reporting_manager_record_id}>
                    {manager.manager_name}
                  </option>
                ))}
              </Select>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={closeManagerModal}>Cancel</Button>
              <Button colorScheme="teal" onClick={handleManagerSubmit} isLoading={managerSubmitting}>Save</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/* ── Delete Confirmation Modal ── */}
      <Modal isOpen={!!deleteData} onClose={!deleteLoading ? () => setDeleteData(null) : undefined}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="red.500">Confirm Deletion</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Are you sure you want to remove <b>{deleteData?.managerName}</b>{' '}
              as reporting manager for <b>{deleteData?.userName}</b>?
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="purple" mr={3} onClick={() => setDeleteData(null)}>Cancel</Button>
            <Button colorScheme="red" onClick={() => handleRemoveManager(deleteData.slot)} isLoading={deleteLoading}>Delete</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewProfile;